var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"257px"}},[_c('a-select',{staticStyle:{"width":"98%"},attrs:{"showSearch":"","mode":_vm.multiple ? 'multiple' : 'default',"optionFilterProp":"children","maxTagTextLength":17,"maxTagCount":1,"placeholder":_vm.$t('filter_by_academicYear'),"options":_vm.options.map(function (el) { return ({
        value: el.ac_year_id,
        id: el.ac_year_id,
        label: el.ac_year
      }); }),"filterOption":function (input, option) { return option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0; }},on:{"change":_vm.changeValue},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }